import enviro from 'enviro';
const TrialIds = {
  SALES_ENTERPRISE: 1,
  MARKETING_ENTERPRISE: 2,
  SERVICE_ENTERPRISE: 3,
  MARKETING_PRO: 4,
  CMS_PROFESSIONAL: 7,
  SALES_PROFESSIONAL: 8,
  SERVICE_PROFESSIONAL: 9,
  CMS_ENTERPRISE: enviro.isProd() ? 18 : 17,
  OPERATIONS_PROFESSIONAL: enviro.isProd() ? 35096 : 43098,
  OPERATIONS_ENTERPRISE: enviro.isProd() ? 52399 : 70192,
  MARKETING_PLUS_PROFESSIONAL_BUNDLE: enviro.isProd() ? 200098 : 270355,
  MARKETING_PLUS_ENTERPRISE_BUNDLE: enviro.isProd() ? 200097 : 270725
};
export const apiNameToTrialIds = {
  'sales-hub-enterprise': TrialIds.SALES_ENTERPRISE,
  'marketing-hub-enterprise': TrialIds.MARKETING_ENTERPRISE,
  'service-hub-enterprise': TrialIds.SERVICE_ENTERPRISE,
  'marketing-hub-professional': TrialIds.MARKETING_PRO,
  'cms-hub-professional': TrialIds.CMS_PROFESSIONAL,
  'sales-hub-professional': TrialIds.SALES_PROFESSIONAL,
  'service-hub-professional': TrialIds.SERVICE_PROFESSIONAL,
  'cms-hub-enterprise': TrialIds.CMS_ENTERPRISE,
  'operations-hub-professional': TrialIds.OPERATIONS_PROFESSIONAL,
  'operations-hub-enterprise': TrialIds.OPERATIONS_ENTERPRISE,
  'marketing-plus-professional-bundle': TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE,
  'marketing-plus-enterprise-bundle': TrialIds.MARKETING_PLUS_ENTERPRISE_BUNDLE
};
export const TRIAL_STANDARD_DURATION = 14;
export let FeatureSurveyKeys;
(function (FeatureSurveyKeys) {
  FeatureSurveyKeys["FORECASTS"] = "forecasts";
  FeatureSurveyKeys["PRODUCTS"] = "products";
  FeatureSurveyKeys["WORKFLOWS"] = "workflows";
  FeatureSurveyKeys["QUOTES"] = "quotes";
  FeatureSurveyKeys["SEQUENCES"] = "sequences";
  FeatureSurveyKeys["SALES_ANALYTICS"] = "salesAnalytics";
  FeatureSurveyKeys["CUSTOM_REPORTS_BUILDER"] = "customReportsBuilder";
  FeatureSurveyKeys["SOCIAL"] = "social";
  FeatureSurveyKeys["CAMPAIGNS"] = "campaigns";
  FeatureSurveyKeys["SERVICE_ESSENTIALS"] = "serviceEssentials";
  FeatureSurveyKeys["CUSTOMER_PORTAL"] = "customerPortal";
  FeatureSurveyKeys["KNOWLEDGE_BASE"] = "knowledgeBase";
  FeatureSurveyKeys["SLA"] = "sla";
  FeatureSurveyKeys["AUTOMATE_FORMATTING"] = "automateFormatting";
  FeatureSurveyKeys["WEBHOOKS"] = "webhooks";
  FeatureSurveyKeys["CUSTOM_CODED_WORKFLOW_ACTIONS"] = "customCodedWorkflowActions";
  FeatureSurveyKeys["TRIGGER_WORKFLOWS"] = "triggerWorkflows";
  FeatureSurveyKeys["DATA_QUATLITY_COMMAND_CENTER"] = "dataQualityCommandCenter";
  FeatureSurveyKeys["OTHER"] = "other";
  FeatureSurveyKeys["CONTENT_ESSENTIALS"] = "contentEssentials";
  FeatureSurveyKeys["CONTENT_CREATION"] = "contentCreation";
  FeatureSurveyKeys["CONTENT_STRATEGY"] = "contentStrategy";
  FeatureSurveyKeys["PERSONALIZATION"] = "personalization";
  FeatureSurveyKeys["SEO"] = "seo";
})(FeatureSurveyKeys || (FeatureSurveyKeys = {}));
export const MarketingHubProDefaultSurveyResponses = {
  social: {
    featureKey: FeatureSurveyKeys.SOCIAL,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.social'
  },
  seo: {
    featureKey: FeatureSurveyKeys.SEO,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.seo'
  },
  workflows: {
    featureKey: FeatureSurveyKeys.WORKFLOWS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.workflows'
  },
  campaigns: {
    featureKey: FeatureSurveyKeys.CAMPAIGNS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.campaigns'
  },
  customReportsBuilder: {
    featureKey: FeatureSurveyKeys.CUSTOM_REPORTS_BUILDER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.customReportsBuilder'
  },
  other: {
    featureKey: FeatureSurveyKeys.OTHER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.other'
  }
};
export const SalesHubProDefaultSurveyResponses = {
  forecasts: {
    featureKey: FeatureSurveyKeys.FORECASTS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.forecasts'
  },
  products: {
    featureKey: FeatureSurveyKeys.PRODUCTS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.products'
  },
  quotes: {
    featureKey: FeatureSurveyKeys.QUOTES,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.quotes'
  },
  workflows: {
    featureKey: FeatureSurveyKeys.WORKFLOWS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.workflows'
  },
  sequences: {
    featureKey: FeatureSurveyKeys.SEQUENCES,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.sequences'
  },
  salesAnalytics: {
    featureKey: FeatureSurveyKeys.SALES_ANALYTICS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.salesAnalytics'
  },
  other: {
    featureKey: FeatureSurveyKeys.OTHER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.other'
  }
};
export const ServiceHubProDefaultSurveyResponses = {
  sla: {
    featureKey: FeatureSurveyKeys.SLA,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.sla'
  },
  customerPortal: {
    featureKey: FeatureSurveyKeys.CUSTOMER_PORTAL,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.customerPortal'
  },
  knowledgeBase: {
    featureKey: FeatureSurveyKeys.KNOWLEDGE_BASE,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.knowledgeBase'
  },
  serviceEssentials: {
    featureKey: FeatureSurveyKeys.SERVICE_ESSENTIALS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.serviceEssentials'
  },
  workflows: {
    featureKey: FeatureSurveyKeys.WORKFLOWS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.workflows'
  },
  other: {
    featureKey: FeatureSurveyKeys.OTHER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.other'
  }
};
export const CMSHubProDefaultSurveyResponses = {
  contentEssentials: {
    featureKey: FeatureSurveyKeys.CONTENT_ESSENTIALS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.contentEssentials'
  },
  contentCreation: {
    featureKey: FeatureSurveyKeys.CONTENT_CREATION,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.contentCreation'
  },
  contentStrategy: {
    featureKey: FeatureSurveyKeys.CONTENT_STRATEGY,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.contentStrategy'
  },
  personalization: {
    featureKey: FeatureSurveyKeys.PERSONALIZATION,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.personalization'
  },
  other: {
    featureKey: FeatureSurveyKeys.OTHER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.other'
  }
};
export const OperationsHubProDefaultSurveyResponses = {
  triggerWorkflows: {
    featureKey: FeatureSurveyKeys.TRIGGER_WORKFLOWS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.triggerWorkflows'
  },
  automateFormatting: {
    featureKey: FeatureSurveyKeys.AUTOMATE_FORMATTING,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.automateFormatting'
  },
  dataQualityCommandCenter: {
    featureKey: FeatureSurveyKeys.DATA_QUATLITY_COMMAND_CENTER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.dataQualityCommandCenter'
  },
  webhooks: {
    featureKey: FeatureSurveyKeys.WEBHOOKS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.webhooks'
  },
  customCodedWorkflowActions: {
    featureKey: FeatureSurveyKeys.CUSTOM_CODED_WORKFLOW_ACTIONS,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.customCodedWorkflowActions'
  },
  other: {
    featureKey: FeatureSurveyKeys.OTHER,
    isSelected: false,
    translationKey: 'purchaseMotions.trial.featureSurvey.features.other'
  }
};
export const NEXT_STEPS_SURVEY_API_NAMES = ['marketing-hub-enterprise', 'sales-hub-enterprise', 'service-hub-enterprise', 'operations-hub-enterprise'];
export const nextStepsSurveyOptions = {
  CREATE_NEW_USERS: 'createNewUsers',
  SPECIFIC_FEATURE: 'specificFeature',
  EXPLORE_ON_YOUR_OWN: 'exploreOnYourOwn'
};
export const enterpriseDefaultSurveyResponseMap = {
  'marketing-hub-enterprise': ['landing-pages', 'email', 'marketing-workflows', 'content-strategy'],
  'sales-hub-enterprise': ['sales-workflows', 'playbooks', 'sequences', 'quotes'],
  'service-hub-enterprise': ['tickets', 'feedback', 'knowledge-base', 'service-workflows'],
  'operations-hub-enterprise': ['datasets', 'snowflake-data-share']
};
export const proDefaultSurveyResponseMap = {
  'marketing-hub-professional': MarketingHubProDefaultSurveyResponses,
  'sales-hub-professional': SalesHubProDefaultSurveyResponses,
  'service-hub-professional': ServiceHubProDefaultSurveyResponses,
  'cms-hub-professional': CMSHubProDefaultSurveyResponses,
  'operations-hub-professional': OperationsHubProDefaultSurveyResponses
};